module.exports = __webpack_public_path__ + "static/img/14000201.65e5a5f0.png";